import ItemCardSmallSidebar from './itemCardSmallSidebar'

export default ItemCardSmallSidebar
